module.exports = __webpack_public_path__ + "img/undraw_create_f05x.cfc2d936.svg";